import { format, parse } from "date-fns";
import { useContext, useState } from "react";
import DatePicker from "react-date-picker";

import IconCheck from "../../images/icon_check.svg";
import LoadingIcon from "../../images/icon_loading_green.gif";
import {
  AREAS,
  BUSINESSES,
  COUNTRIES,
  CURRENCIES,
  DEPARTMENTS,
  DOCUMENTS,
  PROCESSES,
  REASONS,
} from "../../utils/complaintsConstants";
import { FILE_FORMATS } from "../../utils/constants";
import FileUploadInput from "../FileUploadInput/FileUploadInput";
import Input from "../Input/Input";
import { QuejaReclamoContext } from "../QuejaReclamoContext/QuejaReclamoContext";
import Select from "../Select/Select";
import {
  ButtonContainer,
  CancelButton,
  CheckBox,
  Container,
  GrayText,
  Grid,
  Header,
  InfoContainer,
  MainButton,
  SubContainer,
  Subtitle,
  SubtitleFile,
  TextArea,
  TextContainer,
} from "./CreateComplainantInfoStyles";

const MAX_FILES = 15;

function CreateComplainantInfo(props) {
  const maxLength = 30;
  const { onFinished, onReturn } = props;
  const [, , complainantInfo, updateComplainantInfo] =
    useContext<any>(QuejaReclamoContext);
  const [waitingForServerResponse, updateWaitingForServerResponse] =
    useState(false);

  const [errorArea, updateErrorArea] = useState(false);
  const [errorProcess, updateErrorProcess] = useState(false);
  const [errorDocument, updateErrorDocument] = useState(false);
  const [errorDocumentNumber, updateErrorDocumentNumber] = useState(false);
  const [errorCountry, updateErrorCountry] = useState(false);
  const [errorDepartment, updateErrorDepartment] = useState(false);
  const [errorReason, updateErrorReason] = useState(false);
  const [errorCurrency, updateErrorCurrency] = useState(false);
  const [errorAmount, updateErrorAmount] = useState(false);
  const [errorCaseDetail, updateErrorCaseDetail] = useState(false);
  const [errorDemand, updateErrorDemand] = useState(false);

  const onClick = () => {
    if (complainantInfo.area.length === 0) updateErrorArea(true);
    if (complainantInfo.process.length === 0) updateErrorProcess(true);
    if (complainantInfo.document.length === 0) updateErrorDocument(true);
    if (complainantInfo.documentNumber.length === 0)
      updateErrorDocumentNumber(true);
    if (complainantInfo.country.length === 0) updateErrorCountry(true);
    if (complainantInfo.department.length === 0) updateErrorDepartment(true);
    if (complainantInfo.reason.length === 0) updateErrorReason(true);
    if (!complainantInfo.checkedQueja && complainantInfo.currency.length === 0)
      updateErrorCurrency(true);
    if (
      !complainantInfo.checkedQueja &&
      (complainantInfo.amount === "" || complainantInfo.amount === null)
    ) {
      updateErrorAmount(true);
    }
    if (complainantInfo.caseDetail.length === 0) updateErrorCaseDetail(true);
    if (
      !complainantInfo.checkedQueja &&
      (complainantInfo.demand === "" || complainantInfo.demand === null)
    ) {
      updateErrorDemand(true);
    }
    if (
      complainantInfo.area.length !== 0 &&
      complainantInfo.process.length !== 0 &&
      complainantInfo.document.length !== 0 &&
      complainantInfo.documentNumber.length !== 0 &&
      complainantInfo.country.length !== 0 &&
      complainantInfo.department.length !== 0 &&
      complainantInfo.reason.length !== 0 &&
      (complainantInfo.checkedQueja || complainantInfo.currency.length !== 0) &&
      (complainantInfo.checkedQueja ||
        (complainantInfo.amount !== "" && complainantInfo.amount !== null)) &&
      complainantInfo.caseDetail.length !== 0 &&
      (complainantInfo.checkedQueja || complainantInfo.demand.length !== 0)
    ) {
      updateWaitingForServerResponse(true);
      onFinished()
        .then(() => updateWaitingForServerResponse(false))
        .catch(() => updateWaitingForServerResponse(false));
    }
  };

  const [listOfAreas, updateListOfAreas] = useState(
    complainantInfo.checkedQueja ? AREAS.queja : AREAS.reclamo
  );

  const [listOfProcesses, updateListOfProcesses] = useState(
    complainantInfo.area
      ? PROCESSES[complainantInfo.area]
      : [{ value: "", label: "(Seleccione un proceso)" }]
  );
  const [listOfReasons, updateListOfReasons] = useState(
    complainantInfo.checkedQueja ? REASONS.queja : REASONS.reclamo
  );
  const [listOfDocuments, updateListOfDocuments] = useState(
    complainantInfo.checkedQueja ? DOCUMENTS.queja : DOCUMENTS.reclamo
  );

  const onCheckedQuejaChange = () => {
    updateComplainantInfo({
      ...complainantInfo,
      checkedQueja: !complainantInfo.checkedQueja,
      area: "",
      reason: "",
      document: "",
      process: "",
    });
    updateListOfAreas(
      complainantInfo.checkedQueja ? AREAS.reclamo : AREAS.queja
    );
    updateListOfReasons(
      complainantInfo.checkedQueja ? REASONS.reclamo : REASONS.queja
    );
    updateListOfDocuments(
      complainantInfo.checkedQueja ? DOCUMENTS.reclamo : DOCUMENTS.queja
    );
  };

  const onBusinessChange = (ev) => {
    updateComplainantInfo({ ...complainantInfo, business: ev.target.value });
  };
  const onDateChange = (newDate) => {
    updateComplainantInfo({ ...complainantInfo, date: newDate });
  };
  const onAreaChange = (ev) => {
    if (errorArea) updateErrorArea(false);
    updateListOfProcesses(PROCESSES[ev.target.value]);
    updateComplainantInfo({
      ...complainantInfo,
      area: ev.target.value,
      process: "",
    });
  };
  const onProcessChange = (ev) => {
    if (errorProcess) updateErrorProcess(false);
    updateComplainantInfo({ ...complainantInfo, process: ev.target.value });
  };
  const onDocumentChange = (ev) => {
    if (errorDocument) updateErrorDocument(false);
    updateComplainantInfo({ ...complainantInfo, document: ev.target.value });
  };
  const onDocumentNumberChange = (ev) => {
    if (errorDocumentNumber) updateErrorDocumentNumber(false);
    updateComplainantInfo({
      ...complainantInfo,
      documentNumber: ev.target.value,
    });
  };
  const onCountryChange = (ev) => {
    if (errorCountry) updateErrorCountry(false);
    updateComplainantInfo({ ...complainantInfo, country: ev.target.value });
  };
  const onDepartmentChange = (ev) => {
    if (errorDepartment) updateErrorDepartment(false);
    updateComplainantInfo({ ...complainantInfo, department: ev.target.value });
  };
  const onReasonChange = (ev) => {
    if (errorReason) updateErrorReason(false);
    updateComplainantInfo({ ...complainantInfo, reason: ev.target.value });
  };

  const onCurrencyChange = (ev) => {
    if (errorCurrency) updateErrorCurrency(false);
    updateComplainantInfo({ ...complainantInfo, currency: ev.target.value });
  };

  const onAmountChange = (ev) => {
    if (errorAmount) updateErrorAmount(false);
    updateComplainantInfo({ ...complainantInfo, amount: ev.target.value });
  };

  const onCaseDetailChange = (ev) => {
    if (errorCaseDetail) updateErrorCaseDetail(false);
    updateComplainantInfo({ ...complainantInfo, caseDetail: ev.target.value });
  };

  const onDemandChange = (ev) => {
    if (errorDemand) updateErrorDemand(false);
    updateComplainantInfo({ ...complainantInfo, demand: ev.target.value });
  };

  const onFilesChange = (newFiles) => {
    updateComplainantInfo({ ...complainantInfo, files: newFiles });
  };

  const populateSelect = (options) => {
    return options.map((e, index) => {
      if (e.value === "") {
        return (
          <option key={index} disabled value={e.value}>
            {e.label}
          </option>
        );
      }
      return (
        <option key={index} value={e.value}>
          {e.label}
        </option>
      );
    });
  };

  const newDate = new Date();
  const dateMinimo = newDate.setFullYear(newDate.getFullYear() - 2);
  const formatedDate = format(dateMinimo, "yyyy-MM-dd");
  const dateMin = parse(formatedDate, "yyyy-MM-dd", new Date());

  const isButtonDisabled =
    complainantInfo.date.length === 0 ||
    complainantInfo.area.length === 0 ||
    complainantInfo.process.length === 0 ||
    complainantInfo.document.length === 0 ||
    complainantInfo.documentNumber.length === 0 ||
    complainantInfo.country.length === 0 ||
    complainantInfo.department.length === 0 ||
    complainantInfo.reason.length === 0 ||
    complainantInfo.caseDetail.length === 0 ||
    (!complainantInfo.checkedQueja &&
      (complainantInfo.currency.length === 0 ||
        complainantInfo.amount.length === 0)) ||
    (!complainantInfo.checkedQueja && complainantInfo.demand.length === 0) ||
    complainantInfo.files.length === 0;
  return (
    <Container>
      <SubContainer>
        <Header>
          <h2>Categoria</h2>
          <CheckBox>
            <label>
              <input
                className="clickable-element"
                type="radio"
                checked={complainantInfo.checkedQueja}
                onChange={onCheckedQuejaChange}
              />
              Queja
            </label>
          </CheckBox>
          <CheckBox>
            <label>
              <input
                className="clickable-element"
                type="radio"
                checked={!complainantInfo.checkedQueja}
                onChange={onCheckedQuejaChange}
              />
              Reclamo
            </label>
          </CheckBox>
        </Header>

        <InfoContainer>
          <p>
            <span>Quejas: </span> Malestar o descontento por algo que está
            relacionado directamente al producto o servicio comprado, o se
            refiere a la atención al público
          </p>
          <p>
            <span>Reclamos: </span> Disconformidad relacionada con los bienes o
            servicios adquiridos.
          </p>
        </InfoContainer>

        <Grid>
          <div className="item-a">
            <Subtitle>Negocio (*)</Subtitle>
            <Select
              className="clickable-element"
              width="44rem"
              height="5rem"
              value={complainantInfo.business}
              onChange={onBusinessChange}
            >
              {[...populateSelect(BUSINESSES)]}
            </Select>
          </div>
          <div className="item-b">
            <Subtitle>Fecha (*)</Subtitle>
            <div>
              <DatePicker
                className="clickable-element"
                value={complainantInfo.date}
                onChange={onDateChange}
                clearIcon={null}
                dayPlaceholder={"dd"}
                locale={"es-PE"}
                monthPlaceholder={"mm"}
                showLeadingZeros={true}
                yearPlaceholder={"yy"}
                maxDate={new Date()}
                minDate={dateMin}
              />
            </div>
          </div>
          <div className="item-a">
            <Subtitle>Área (*)</Subtitle>
            <Select
              className="clickable-element"
              width="44rem"
              height="5rem"
              value={complainantInfo.area}
              onChange={onAreaChange}
              hasError={errorArea}
            >
              {[...populateSelect(listOfAreas)]}
            </Select>
          </div>
          <div className="item-b">
            <Subtitle>Proceso (*)</Subtitle>
            <Select
              className="clickable-element"
              width="44rem"
              height="5rem"
              value={complainantInfo.process}
              onChange={onProcessChange}
              hasError={errorProcess}
            >
              {[...populateSelect(listOfProcesses)]}
            </Select>
          </div>
          <div className="item-a">
            <Subtitle>Documento (*)</Subtitle>
            <Select
              className="clickable-element"
              width="44rem"
              height="5rem"
              value={complainantInfo.document}
              onChange={onDocumentChange}
              hasError={errorDocument}
            >
              {[...populateSelect(listOfDocuments)]}
            </Select>
          </div>
          <div className="item-b">
            <Subtitle>Número de documento (*)</Subtitle>
            <Input
              width="44rem"
              height="5rem"
              value={complainantInfo.documentNumber}
              onChange={onDocumentNumberChange}
              placeholder="Nro. del documento"
              hasError={errorDocumentNumber}
              maxLength={maxLength}
            />
          </div>
          <div className="item-a">
            <Subtitle>País (*)</Subtitle>
            <Select
              className="clickable-element"
              width="44rem"
              height="5rem"
              value={complainantInfo.country}
              onChange={onCountryChange}
              hasError={errorCountry}
            >
              {[...populateSelect(COUNTRIES)]}
            </Select>
          </div>
          <div className="item-b">
            <Subtitle>Departamento (*)</Subtitle>
            <Select
              className="clickable-element"
              width="44rem"
              height="5rem"
              value={complainantInfo.department}
              onChange={onDepartmentChange}
              hasError={errorDepartment}
            >
              {[...populateSelect(DEPARTMENTS)]}
            </Select>
          </div>
          <div className="item-a">
            <Subtitle>Motivo (*)</Subtitle>
            <Select
              className="clickable-element"
              width="44rem"
              height="5rem"
              value={complainantInfo.reason}
              onChange={onReasonChange}
              hasError={errorReason}
            >
              {[...populateSelect(listOfReasons)]}
            </Select>
          </div>
          {!complainantInfo.checkedQueja ? (
            <div className="item-b">
              <Subtitle>Monto (*) </Subtitle>
              <div className="auxiliar">
                <Select
                  width="24rem"
                  height="5rem"
                  value={complainantInfo.currency}
                  onChange={onCurrencyChange}
                  hasError={errorCurrency}
                >
                  {[...populateSelect(CURRENCIES)]}
                </Select>
                <Input
                  width="18.4rem"
                  height="5rem"
                  value={complainantInfo.amount}
                  onChange={onAmountChange}
                  placeholder="Ingrese un monto"
                  hasError={errorAmount}
                />
              </div>
            </div>
          ) : null}
        </Grid>
        <TextContainer>
          <Subtitle>Detalle de caso (*)</Subtitle>
          <TextArea
            type="text"
            placeholder={"Escribe algo..."}
            onChange={onCaseDetailChange}
            value={complainantInfo.caseDetail}
            hasError={errorCaseDetail}
          />
        </TextContainer>

        {!complainantInfo.checkedQueja && (
          <TextContainer>
            <Subtitle>Pedido (*)</Subtitle>
            <TextArea
              type="text"
              placeholder={"Escribe algo..."}
              onChange={onDemandChange}
              value={complainantInfo.demand}
              hasError={errorDemand}
            />
          </TextContainer>
        )}
        <div>
          <SubtitleFile>Adjuntar Archivos (*)</SubtitleFile>
          <FileUploadInput
            onValueChange={onFilesChange}
            value={complainantInfo.files}
            maxFiles={MAX_FILES}
            formats={[
              FILE_FORMATS.IMAGE,
              FILE_FORMATS.PDF,
              FILE_FORMATS.ZIP,
              FILE_FORMATS.EXCEL,
            ]}
            width="90rem"
          />
        </div>

        <GrayText>
          Si dispones de documentos asociados al caso puedes adjuntarlos en los
          formatos más comunes.
        </GrayText>

        <ButtonContainer>
          <CancelButton onClick={onReturn}>Cancelar</CancelButton>
          <MainButton
            isDisabled={isButtonDisabled}
            onClick={onClick}
            disabled={waitingForServerResponse}
          >
            {!waitingForServerResponse ? (
              <img src={IconCheck} className="check" alt="check" />
            ) : (
              <img src={LoadingIcon} className="spinner" alt="spinner" />
            )}
            Enviar queja/reclamos
          </MainButton>
        </ButtonContainer>
      </SubContainer>
    </Container>
  );
}

export default CreateComplainantInfo;
